module.exports = __webpack_public_path__ + "img/admin-menu.815dd305.svg";